import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { PickingFile } from "interfaces/picking-file";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_PICKING_FILES" }
);

export interface ListPickingFilesState extends IState {
  data: PickingFile[];
}

interface ISuccessListPickingFilesAction extends ISuccessAction {
  data: PickingFile[];
}

const INITIAL_STATE: ListPickingFilesState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListPickingFilesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListPickingFilesState, 
  action: ISuccessListPickingFilesAction,
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListPickingFilesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listPickingFiles = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListPickingFilesTypes = Types;
export const ListPickingFilesActions = Creators;
